module.exports = __webpack_public_path__ + "static/media/wirecutter-1.3aff952f.png";